<article class="outcome-tile box break rel l_flex content--article">
  <!-- <article> is most appropriate here: http://stackoverflow.com/questions/3255109/marking-up-a-search-result-list-with-html5-semantics -->

  <div
    class="l_flex m-l_flex l_flex-column full-width"
    [class.tile--selected]="isSelected"
  >
    <div class="l_flex-grow-vertical">
      <div class="rel guts-m-h-1 guts-m-t-1">
        <div
          *ngIf="userOutcomeContent.contentType !== 'Badge'"
          class="
            l_flex
            m-l_flex
            outcome-tile__item
            l_flex-middle l_flex-justify-center l_flex-middle
          "
        >
          <df-icon
            icon="{{ userOutcomeContent.contentType | lowercase }}"
            class="color-fuchsia zoom-icon"
            size="large"
          ></df-icon>
        </div>

        <div
          *ngIf="userOutcomeContent.contentType === 'Badge'"
          class="
            l_flex
            m_l-flex
            l_flex-justify-center
            outcome-tile__badge-container
          "
        >
          <img
            class="outcome-tile__badge"
            [src]="userOutcomeContent.imageUrl"
          />
        </div>
      </div>

      <!-- Body -->
      <div
        class="
          guts-m-t-2 guts-m-h-2
          l_flex
          m-l_flex
          l_flex-column l_flex-grow-vertical
        "
      >
        <dgx-learning-resource-metadata
          [metaData]="{
            resourceLabel: titleTranslationMap[userOutcomeContent.contentType]
          }"
          [config]="{ compact: true }"
        ></dgx-learning-resource-metadata>
        <div
          #title
          class="outcome-tile__title"
          [ngClass]="{
            'outcome-tile__title--max-height': expandCard,
            'outcome-tile__title--hide-overflow': !expandCard
          }"
        >
          <h4 class="h4">
            {{ userOutcomeContent.title }}
          </h4>
          <button
            *ngIf="showEllipsis && !expandCard"
            class="outcome-tile__ellipsis"
            [attr.title]="i18n.A11y_ExpandForTitle"
            [attr.aria-label]="i18n.A11y_ExpandForTitle"
            (click)="onEllipsisClick(title)"
           data-dgat="user-outcome-tile-v2-9f0">
            ...
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="cursor-default guts-p-full-1">
      <div>
        <div *ngIf="authUser && !hideMenu" class="l_flexbar l_flex-justify">
          <button
            df-button
            dfButtonType="passive"
            df-button-small
            (click)="showDetails()"
            class="guts-m-r-1"
            data-dgat="user-outcome-tile-v2-015"
          >
            {{ 'Core_ViewDetails' | translate }}
          </button>
          <dgx-user-outcome-actions
            [item]="userOutcome"
            [contentType]="userOutcomeContent.contentType"
            [itemId]="userOutcomeContent.userOutcomeId"
            [showSelectOption]="ownerIsViewing && showSelectOption"
            class="guts-p-r-half"
          ></dgx-user-outcome-actions>
        </div>
      </div>
    </footer>
  </div>
</article>
